import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import styled from 'styled-components';
import { PlainTextField, RichTextField } from '@components/shared/vms/CommonTypes';
import { BREAKPOINT } from '@constants';
import { Gradient2Style } from '../SharedStyles';
import { TEXT_STYLES, TextVariant, Typography } from './Typography';

interface StoreFrontModuleHeadProps {
  centeredText?: boolean;
  overline?: PlainTextField | null;
  heading?: RichTextField | null;
  subheading?: RichTextField | null;
}

const StorefrontModuleHead: React.FC<StoreFrontModuleHeadProps> = ({ centeredText, overline, heading, subheading }) => {
  if (!heading && !subheading && !overline) {
    return null;
  }

  return (
    <Head $centeredText={centeredText ?? false}>
      {overline && (
        <Typography $variant={TextVariant.UpperText4} as="h3">
          {overline}
        </Typography>
      )}
      {heading?.richText && heading.richText.length > 0 && (
        <Heading>
          <PrismicRichText field={heading.richText} />
        </Heading>
      )}
      {subheading?.richText && subheading.richText.length > 0 && (
        <SubHeading>
          <PrismicRichText field={subheading.richText} />
        </SubHeading>
      )}
    </Head>
  );
};

export default StorefrontModuleHead;

const Head = styled.div<{ $centeredText: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 0px;
  align-items: ${(props) => (props.$centeredText ? 'center' : 'flex-start')};
  width: 100%;
  text-align: ${(props) => (props.$centeredText ? 'center' : 'left')};
`;

const Heading = styled.div`
  & > * {
    ${TEXT_STYLES[TextVariant.Heading3]};
    text-align: inherit;
    color: inherit;

    @media (max-width: ${BREAKPOINT.tablet}px) {
      ${TEXT_STYLES[TextVariant.Heading5]};
    }

    & > span.italic {
      font-style: italic;
    }

    & span.gradient2 {
      ${Gradient2Style}
    }
  }
`;

const SubHeading = styled.div`
  margin-top: 16px;

  & > * {
    ${TEXT_STYLES[TextVariant.BodyRegularLG]};
    text-align: inherit;
    color: inherit;

    @media (max-width: ${BREAKPOINT.tablet}px) {
      ${TEXT_STYLES[TextVariant.BodyRegularMD]};
    }

    & > span.italic {
      font-style: italic;
    }
  }
`;
